import Layout from './base/layout';

(() => {
    const layout = new Layout();
    layout.init();
})();